import { styled } from 'enova-frontend-components';
import { useFormContext } from 'react-hook-form';
import { Card, Fieldset, Heading, Paragraph, Radio, Textfield, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { VentilasjonFormData } from '../types';
import { CardContentWrapper } from '../../../solceller/form/components/styledComponents';
import { JaNeiVetIkke } from '../../../../utils/registerEnums';
import { useSolcellerValidation } from '../../../solceller/form/components/useSolcellerValidation';

import { VarmegjenvinnerSelect } from './varmegjenvinnerSelect';

const StyledCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
  padding: var(--ds-size-4);
  margin-top: var(--ds-size-2);
  width: 100%;
  background: var(--ds-color-background-tinted);
`;

// These fields are only rendered if Balansert ventilasjon is selected, hence why alle fields
// have shouldUnregister set to true

export const BalansertVentilasjonInputs = () => {
  const { validateYear, yearPattern } = useSolcellerValidation();
  const { register, watch, formState } = useFormContext<VentilasjonFormData>();
  const { t } = useTranslation();

  const hasGjenvinningAvVarme = watch('gjenvinningAvVarme') === 'ja';

  const { errors } = formState;

  return (
    <div>
      <Heading level={2} data-size="xs">
        {t('register.ventilation.form.balansert.title')}
      </Heading>
      <Paragraph>{t('register.ventilation.form.balansert.description')}</Paragraph>
      <StyledCard>
        <CardContentWrapper>
          <Textfield
            maxLength={4}
            inputMode="numeric"
            label={t('register.ventilation.form.installationYear.label')}
            error={errors.installasjonsAr?.message}
            {...register('installasjonsAr', {
              validate: (value) => validateYear(value?.toString()),
              pattern: yearPattern,
              shouldUnregister: true
            })}
          />

          <Fieldset>
            <Fieldset.Legend>{t('register.ventilation.form.service.label')}</Fieldset.Legend>
            <Radio
              {...register('serviceGjennomfortSiste2Ar', {
                required: t('register.ventilation.form.service.error'),
                shouldUnregister: true
              })}
              label={t('register.ja')}
              value={JaNeiVetIkke.Ja}
            />
            <Radio
              {...register('serviceGjennomfortSiste2Ar', {
                required: t('register.ventilation.form.service.error'),
                shouldUnregister: true
              })}
              label={t('register.nei')}
              value={JaNeiVetIkke.Nei}
            />
            <Radio
              {...register('serviceGjennomfortSiste2Ar', {
                required: t('register.ventilation.form.service.error'),
                shouldUnregister: true
              })}
              label={t('register.vetIkke')}
              value={JaNeiVetIkke.VetIkke}
            />
            {formState.errors.serviceGjennomfortSiste2Ar && (
              <ValidationMessage data-color="danger">
                {formState.errors.serviceGjennomfortSiste2Ar.message}
              </ValidationMessage>
            )}
          </Fieldset>

          <Fieldset>
            <Fieldset.Legend>{t('register.ventilation.form.vermegjenvinning.label')}</Fieldset.Legend>
            <Radio
              {...register('gjenvinningAvVarme', {
                required: t('register.ventilation.form.vermegjenvinning.error'),
                shouldUnregister: true
              })}
              label={t('register.ja')}
              value={JaNeiVetIkke.Ja}
            />
            <Radio
              {...register('gjenvinningAvVarme', {
                required: t('register.ventilation.form.vermegjenvinning.error'),
                shouldUnregister: true
              })}
              label={t('register.nei')}
              value={JaNeiVetIkke.Nei}
            />
            <Radio
              {...register('gjenvinningAvVarme', {
                required: t('register.ventilation.form.vermegjenvinning.error'),
                shouldUnregister: true
              })}
              label={t('register.vetIkke')}
              value={JaNeiVetIkke.VetIkke}
            />
            {formState.errors.gjenvinningAvVarme && (
              <ValidationMessage data-color="danger">{formState.errors.gjenvinningAvVarme.message}</ValidationMessage>
            )}
            {hasGjenvinningAvVarme && <VarmegjenvinnerSelect />}
          </Fieldset>
        </CardContentWrapper>
      </StyledCard>
    </div>
  );
};
